import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import stl from "./carDetailsSection.module.css";
import SingleCarCC from "./SingleCarCC";
import FuelEco from "@/pages/post/components/carDetailsSection/FuelEco/FuelEco";
var SinglePanel = function SinglePanel(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: props.hasIdForScroll ? "scrollMeMazeedNew" : "car-info-panel-".concat(props.idSep),
    className: ["scrollTmeMF" + props.idSep, stl.singlePanContainer, props.isActive ? stl.darkBG : undefined].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.spHead,
    onClick: props.setNewPan,
    id: "panel-header-".concat(props.idSep)
  }, /*#__PURE__*/React.createElement("h3", {
    id: "panel-title-".concat(props.idSep)
  }, props.title), /*#__PURE__*/React.createElement("img", {
    className: props.isActive ? stl.rotateImage : undefined,
    src: CDN_LINK + "/assets/images/roundArrow.svg",
    alt: "icn",
    width: "24px",
    height: "24px",
    id: "panel-arrow-".concat(props.idSep)
  })), props.has2columns ? props.isActive ? /*#__PURE__*/React.createElement("div", {
    className: [stl.doubleCol, stl.panData, props.isActive ? stl.activePan : undefined].join(" "),
    id: "panel-content-".concat(props.idSep)
  }, props.data && Object.keys(props.data).map(function (key, idx) {
    var item = props.data[key];
    return /*#__PURE__*/React.createElement(SingleCarCC, {
      title: item.label,
      icon: item.icon,
      field: item.name,
      key: "SCCC" + idx,
      index: idx,
      colorCode: item.code
    });
  }), props.fuelEco && /*#__PURE__*/React.createElement(FuelEco, {
    fuelEco: props.fuelEco
  })) : /*#__PURE__*/React.createElement(React.Fragment, null) : /*#__PURE__*/React.createElement("div", {
    className: [stl.panData, props.isActive ? stl.activePan : undefined].join(" "),
    id: "panel-content-".concat(props.idSep)
  }, props.data.map(function (item, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: "sr" + idx,
      className: stl.rowCC,
      id: "panel-row-".concat(props.idSep, "-").concat(idx),
      dangerouslySetInnerHTML: {
        __html: item.name.replace(/\n/g, "<br/>")
      }
    });
  }))));
};
export default SinglePanel;